import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Container } from '../../../components/FlightDetails/Footer/components/Container.js';
import { Item } from '../../../components/FlightDetails/Footer/components/Item.js';
import { TextWrapper } from '../../../components/FlightDetails/TextWrapper.js';
import { LabelSmall, ParagraphMediumBold } from '../../../primitives/index.js';
import { qaId } from '../../../utils/index.js';
import { FLIGHT_DETAILS_QA_ID } from '../../../utils/qaId.js';
export const Footer = ({
  date,
  dateLabel,
  alert = false,
  duration,
  durationLabel,
  highlightDate = false
}) => _jsxs(Container, {
  "data-testid": qaId(FLIGHT_DETAILS_QA_ID, 'footer'),
  children: [_jsxs(Item, {
    alert: alert,
    children: [_jsx(ParagraphMediumBold, {
      color: 'inherit',
      children: dateLabel
    }), _jsx(LabelSmall, {
      color: 'inherit',
      children: _jsx(TextWrapper, {
        highlighted: highlightDate,
        children: date
      })
    })]
  }), _jsxs(Item, {
    children: [_jsx(ParagraphMediumBold, {
      children: durationLabel
    }), _jsx(LabelSmall, {
      "data-testid": "shared-flightLayer-tripDuration",
      color: "contentSecondary",
      children: duration
    })]
  })]
});